import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { HubDataTable, type HubDataTableColumn } from "@/components/hub/HubDataTable";
import { PageTitleWithHelp } from "@/components/ui/title-help";
import { apiFetch } from "@/lib/api";

type OrganizationRow = {
  organizationId: number;
  name: string;
  domain: string;
  freshsalesAccountId: string;
};

const COLUMNS: HubDataTableColumn<OrganizationRow>[] = [
  {
    id: "name",
    header: "Name",
    sortValue: (row) => row.name,
    cell: (row) => (
      <Link
        to={`/wireless/organizations/${row.organizationId}`}
        className="text-brand-700 hover:underline"
      >
        {row.name || `Organization ${row.organizationId}`}
      </Link>
    ),
  },
  {
    id: "domain",
    header: "Domain",
    sortValue: (row) => row.domain,
    cell: (row) => row.domain,
  },
  {
    id: "freshsalesAccountId",
    header: "Freshsales account",
    overflow: "nowrap",
    sortValue: (row) => row.freshsalesAccountId,
    cell: (row) => row.freshsalesAccountId,
  },
];

export function WirelessOrganizationsPage() {
  const organizationsQuery = useQuery({
    queryKey: ["wireless", "organizations"],
    queryFn: () => apiFetch<{ organizations: OrganizationRow[] }>("/api/wireless/organizations"),
  });

  return (
    <div className="space-y-4">
      <PageTitleWithHelp hoverHint="Wireless portal customer organizations. Open an organization to browse its groups, users, devices, and events.">
        Organizations
      </PageTitleWithHelp>

      <HubDataTable
        title="Organizations"
        columns={COLUMNS}
        rows={organizationsQuery.data?.organizations ?? []}
        rowKey={(row) => row.organizationId}
        loading={organizationsQuery.isLoading}
        loadingMessage="Loading organizations..."
        error={organizationsQuery.isError ? "Could not load organizations." : null}
        empty="No organizations."
      />
    </div>
  );
}
